<div class="generic-modal"
  data-cy="modal">
  <div class="generic-modal-header warning" data-cy="generic-modal-header">
    <p class="generic-modal-title"
    data-cy="modal-title">Change Supply Packing Plant</p>
    <button (click)="clickCloseButton()"
      [disabled]="loading"
      class="close"
      data-cy="modal-close-button"
    type="button"></button>
  </div>

  <div class="generic-modal-body">
    <div class="pnc-credentials-plant-section"
      data-cy="pnc-create-form-credentials-separator">
      <app-input-dropdown #supplyingPackingPlantInput
        (inputStateChange)="manageSupplyingPackingPlantInputStateChange($event)"
        (inputValueChange)="setSupplyingPackingPlantValue($event)"
        [initialValue]="null"
        [showViewMode]="isViewMode()"
        [alternateBackground]="hasAlternateBackground"
        [inputFormatter]="typeahead.inputTextCodeNameFormatter"
        [messages]="supplyingPackingPlantInputMessages"
        [resultFormatter]="typeahead.inputTextCodeNameFormatter"
        [resultsFunction]="searchSupplyingPackingPlants"
        [validators]="validators.supplyingPackingPlant"
        [warningLevel]="WarningsEnum.WARNING_SAVE"
        baseCypressTag="pnc-form-supplying-packing-plant"
        label="New supplying packing plant"
      placeholder="Select a supplying packing plant"></app-input-dropdown>
    </div>
    <div class="pnc-solution-checkbox-wrapper" data-cy="pnc-solution-checkbox-wrapper">
      <label>
        <input type="checkbox"
          [checked]="isChecked"
          [disabled]="false"
          data-cy="checkbox-eeSpecialist"
          class="pnc-solution-checkbox-input" (change)="check()"/>
        <span class="pnc-solution-checkbox-text" data-cy="pnc-solution-checkbox-text">
          Confirmed with the concerned Material Planner
          <app-warning-star [type]="WarningsEnum.WARNING_SAVE"></app-warning-star>
        </span>
      </label>
    </div>
  </div>

  <div class="generic-modal-footer"
    data-cy="modal-footer">
    <button (click)="clickSecondaryButton()"
      class="btn-secondary"
      data-cy="modal-secondary-button"
    type="button">Discard</button>
    <div class="generic-modal-primary-button-container">
      <button (click)="clickPrimaryButton()"
        class="btn-primary"
        [disabled]="disablePrimaryButton"
        data-cy="modal-primary-button"
      type="button">Confirm</button>
      @if (loading) {
        <app-loading-spinner class="button-spinner"></app-loading-spinner>
      }
    </div>
  </div>
</div>